import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  Label,
  Input,
  FormFeedback,
  Alert,
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { updateLead } from '../../../../redux/actions/lead';
import { useCloseValidation } from './formik';

function CloseForm({ leadId, leadOrder, onSubmit, onCancel }) {
  const dispatch = useDispatch();
  const updateState = useSelector((state) => state.lead.update);
  const [modal, setModal] = useState(true);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const formik = useCloseValidation((values) => {
    setLoading(true);
    setErrorMessage('');

    if (!leadId) {
      setErrorMessage('No se puede procesar: ID de lead no válido.');
      setLoading(false);
      return;
    }

    const leadInfo = {
      state: 'close',
      closeDate: values.date,
      closeComment: values.comment,
      order: leadOrder,
    };

    dispatch(updateLead(leadId, leadInfo));
  });

  const toggle = (operation) => {
    setModal(!modal);
    if (operation === 'submit') {
      onSubmit();
    } else {
      onCancel();
    }
  };

  useEffect(() => {
    if (updateState) {
      setLoading(false);

      if (updateState.status === 'success') {
        toggle('submit');
      } else if (updateState.status === 'danger') {
        setErrorMessage(updateState.message || 'Error al cerrar el lead');
      }
    }
  }, [updateState]);

  return (
    <Modal isOpen={modal} toggle={() => toggle('cancel')}>
      <ModalHeader toggle={() => toggle('cancel')}>Cerrar Lead</ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
          {errorMessage && (
            <Alert color="danger" className="mb-3">
              {errorMessage}
            </Alert>
          )}

          <p>
            Complete la información para cerrar este lead. Indique la fecha de
            cierre y agregue comentarios relevantes.
          </p>

          <section className="mb-3">
            <Label for="date">Fecha de cierre</Label>
            <Input
              type="date"
              name="date"
              id="date"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.date}
              valid={formik.touched.date && !formik.errors.date}
              invalid={formik.touched.date && !!formik.errors.date}
            />
            <FormFeedback>{formik.errors.date}</FormFeedback>
          </section>

          <section className="mb-3">
            <Label for="comment">Comentarios</Label>
            <Input
              type="textarea"
              name="comment"
              id="comment"
              placeholder="Ingrese comentarios sobre el cierre del lead"
              rows="4"
              className="p-2"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.comment}
              valid={formik.touched.comment && !formik.errors.comment}
              invalid={formik.touched.comment && !!formik.errors.comment}
            />
            <FormFeedback>{formik.errors.comment}</FormFeedback>
          </section>
        </ModalBody>
        <ModalFooter>
          <Button
            type="submit"
            color="primary"
            disabled={!formik.isValid || !formik.dirty || loading}
          >
            {loading ? 'Procesando...' : 'Cerrar Lead'}
          </Button>{' '}
          <Button color="secondary" onClick={() => toggle('cancel')}>
            Cancelar
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
}

export default CloseForm;
